import React from 'react';

import {
    countWords,
    truncateString,
} from '../../../utils';
import {
    getClubNameDisplay,
    getEventsListByEventType,
    EventTypes,
} from '../../../utils/clubs';
import { EventScheduleTypes } from '../../../utils/eventConstants';
import Organizers from './Organizers';
import { EventCard, PlayerCard } from '../../cards';
import Linkify from '../../text/Linkify';

import styles from '../../../pages/ClubProfiles/club.scss';
import InvitedPlayerCard from '../../cards/InvitedPlayerCard';
import { CLUB_PROFILE_VIEW_TYPES } from '../../../utils/constants';

class PlayersGroupContent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            descriptionExpanded: false,
            showAllEvents: false,
            playerFilter: 'confirmed',
        };

        this.onShowAllEventsClick = this.onShowAllEventsClick.bind(this);
        this.onPlayerFilterClick = this.onPlayerFilterClick.bind(this);
    }

    onShowAllEventsClick() {
        this.setState(prevState => ({ showAllEvents: !prevState.showAllEvents }));
    }

    onPlayerFilterClick(val) {
        this.setState({
            playerFilter: val,
        });
    }

    render() {
        const {
            showAllEvents,
            playerFilter,
        } = this.state;

        const {
            clubDetails,
            auth,
            clubType,
            sendMessage,
            checkGate,
            featureGates,
        } = this.props;

        const {
            description,
            schoolProfile,
            tierType,
            name,
            clubMembers,
            clubMemberInvites,
        } = clubDetails;

        let clubProfileViewType = null;
        if (tierType?.isCollege) {
            clubProfileViewType = CLUB_PROFILE_VIEW_TYPES.COLLEGE;
        } else if (tierType?.isHighSchool) {
            clubProfileViewType = CLUB_PROFILE_VIEW_TYPES.HIGHSCHOOL;
        } else {
            // for sonar
        }

        const displayName = getClubNameDisplay(tierType, schoolProfile, name);
        const upcomingTmsEvents = clubDetails && getEventsListByEventType(clubDetails, EventScheduleTypes.UPCOMING, EventTypes.TMS);

        const toggleDescriptionExpanded = () => {
            this.setState(prevState => ({ descriptionExpanded: !prevState.descriptionExpanded }));
        };

        return (
            <div className="row">
                <div className="col-md-8">
                    {description && description.length > 0 && (
                        <div>
                            <h6 className="d-block" data-testid="club-profile.overview.about-heading">{`About ${displayName}`}</h6>
                            <Linkify>
                                {countWords(description) < 40
                                    ? (<p className="text-line-break" data-testid="club-profile.overview.description">{description}</p>)
                                    : (
                                        <p className="text-line-break" data-testid="club-profile.overview.description">
                                            {this.state.descriptionExpanded ? clubDetails.description : truncateString(clubDetails.description, 40)}
                                            <span className={`${styles.readMore}`} onClick={toggleDescriptionExpanded} data-testid="club-profile.overview.read-more-btn">{this.state.descriptionExpanded ? 'Read less' : 'Read more'}</span>
                                        </p>
                                    )}
                            </Linkify>
                        </div>
                    )}
                    <div className="d-block d-md-none">
                        <Organizers
                            clubDetails={clubDetails}
                            auth={auth}
                            clubType={clubType}
                            sendMessage={sendMessage}
                        />
                    </div>

                    <h6 data-testid="club-profile.overview.upcoming-events-heading">Upcoming Events</h6>
                    <div className="row">
                        {upcomingTmsEvents && upcomingTmsEvents.length ? upcomingTmsEvents.map((event, i) => {
                            if (showAllEvents || i <= 1) {
                                return (
                                    <div
                                        className="col-12"
                                        key={`event-${i}`}
                                    >
                                        <EventCard
                                            event={event}
                                            auth={auth}
                                            force={{ hideOrganizer: true }}
                                            data-testid={event.id ? `club.overview.event-${event.id}` : `club.overview.event-${i}`}
                                        />
                                    </div>
                                );
                            } return null;
                        }) : <div className="col-12 text-center">No results.</div>}
                    </div>
                    <div
                        className={`${styles.seeMore} mt0 ${upcomingTmsEvents.length > 2 ? 'd-block' : 'd-none'}`}
                        onClick={this.onShowAllEventsClick}
                        data-testid="club-profile.overview.show-all-events-btn"
                    >
                        {showAllEvents ? 'Show less' : 'Show all'}
                    </div>

                    <h6 data-testid="club-profile.overview.players-heading">Players</h6>
                    <div className="bb" />
                    <div className="button-row pb16 pt16">
                        <button
                            type="button"
                            className={`btn btn-sm mr8 ${playerFilter === 'confirmed' ? 'btn-primary' : 'btn-default'}`}
                            onClick={() => this.onPlayerFilterClick('confirmed')}
                            data-testid="club-profile.overview.players-filter.confirmed-btn"
                        >
                            Confirmed
                        </button>
                        <button
                            type="button"
                            className={`btn btn-sm  ${playerFilter === 'invited' ? 'btn-primary' : 'btn-default'}`}
                            onClick={() => this.onPlayerFilterClick('invited')}
                            data-testid="club-profile.overview.players-filter.invited-btn"
                        >
                            Invited
                        </button>
                    </div>
                    <div className="bb mb16" />
                    {playerFilter === 'confirmed' && (
                        <React.Fragment>
                            {(clubMembers && clubMembers.length > 0) ? clubMembers.map((m, i) => {
                                return (
                                    <PlayerCard
                                        key={`m-${i}`}
                                        player={m}
                                        sendMessage={sendMessage}
                                    />
                                );
                            }) : <div className="text-center">No results.</div>}
                        </React.Fragment>
                    )}
                    {playerFilter === 'invited' && (
                        <React.Fragment>
                            {(clubMemberInvites && clubMemberInvites.length > 0) ? clubMemberInvites.filter(i => i.status === 'pending').map((m, i) => {
                                delete m.id;
                                return (
                                    <InvitedPlayerCard
                                        key={`club-invite-${i}`}
                                        player={m}
                                        sendMessage={sendMessage}
                                        clubProfileViewType={clubProfileViewType}
                                        checkGate={checkGate}
                                        featureGates={featureGates}
                                    />
                                );
                            }) : <div className="text-center">No results.</div>}
                        </React.Fragment>
                    )}
                </div>
                <div className="col-md-4">
                    <div className="d-none d-md-block">
                        <Organizers
                            clubDetails={clubDetails}
                            auth={auth}
                            clubType={clubType}
                            sendMessage={sendMessage}
                        />
                    </div>
                </div>
            </div>
        );
    }
}
export default PlayersGroupContent;
